import { render, staticRenderFns } from "./CASEEntityHistory.vue?vue&type=template&id=fe146d14&"
import script from "./CASEEntityHistory.vue?vue&type=script&lang=js&"
export * from "./CASEEntityHistory.vue?vue&type=script&lang=js&"
import style0 from "./CASEEntityHistory.vue?vue&type=style&index=0&id=fe146d14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VSpacer,VTooltip})
